// ImageModal.js
import React from "react";

const ImageModal = ({ src, onClose }) => {
  return (
    <div className="bg-black fixed inset-0 z-50 flex items-center justify-center bg-opacity-50 transition-opacity duration-300">
      <div className="relative mx-4 w-full max-w-[50vw] rounded-lg bg-white p-4 shadow-lg">
        <img
          crossOrigin="anonymous"
          src={src}
          alt="Enlarged"
          className="max-h-[80vh] w-full object-contain"
        />
        <button
          onClick={onClose}
          className="absolute -right-4 -top-4 flex h-8 w-8 items-center justify-center rounded-full bg-red-500 text-lg text-white transition-transform duration-200 hover:scale-110"
        >
          &times;
        </button>
      </div>
    </div>
  );
};

export default ImageModal;
